/**
 * Include your custom JavaScript here.
 */


/* Matarah prefix-first predictive search */
(function () {
  'use strict';

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var rawUrl = typeof input === 'string' ? input : input.url;
        var url = new URL(rawUrl, window.location.origin);
        if (url.pathname.indexOf('/search/suggest') !== -1) {
          url.searchParams.set('resources[limit]', '10');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[options][fields]', 'title,variants.sku');
          input = typeof input === 'string' ? url.toString() : new Request(url.toString(), input);
        }
      } catch (error) {}
      return nativeFetch.call(this, input, init);
    };
  }

  function normalize(value) {
    return (value || '').trim().toLocaleLowerCase('he-IL');
  }

  function filterPredictiveResults() {
    var input = document.querySelector('.search-bar__input');
    var container = document.querySelector('.search-bar__results-inner');
    if (!input || !container) return;

    var query = normalize(input.value);
    if (!query || /^\d+$/.test(query)) return;

    var localList = container.querySelector('.search-bar__result-products');
    if (localList && localList.hasAttribute('data-matarah-signature')) return;

    var items = container.querySelectorAll('.search-bar__result-products .search-bar__result-item');
    var visible = 0;

    items.forEach(function (item) {
      var titleNode = item.querySelector('.search-bar__item-title');
      var title = normalize(titleNode ? titleNode.textContent : '');
      var show = title.indexOf(query) === 0;
      item.hidden = !show;
      item.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    var productHeading = container.querySelector('.search-bar__result-category');
    if (productHeading && items.length) {
      productHeading.hidden = visible === 0;
      productHeading.style.display = visible === 0 ? 'none' : '';
    }
  }

  document.addEventListener('input', function (event) {
    if (event.target && event.target.matches('.search-bar__input')) {
      window.setTimeout(filterPredictiveResults, 80);
      window.setTimeout(filterPredictiveResults, 350);
      window.setTimeout(filterPredictiveResults, 900);
    }
  });

  var observer = new MutationObserver(filterPredictiveResults);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Matarah predictive-search XHR limit */
(function () {
  'use strict';
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, rawUrl) {
    try {
      var url = new URL(rawUrl, window.location.origin);
      if (url.pathname.indexOf('/search/suggest') !== -1) {
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][fields]', 'title,variants.sku');
        arguments[1] = url.toString();
      }
    } catch (error) {}
    return nativeOpen.apply(this, arguments);
  };
})();


/* Matarah local title-prefix index (prices are loaded LIVE from Shopify, never from the static index) */
(function () {
  'use strict';

  var products = null;
  var renderTimer = null;
  var laterTimer = null;
  var priceCache = {};

  function normalize(value) {
    return (value || '').trim().toLocaleLowerCase('he-IL');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function assetUrl() {
    var scripts = document.querySelectorAll('script[src*="/assets/custom.js"]');
    var src = scripts.length ? scripts[scripts.length - 1].src : '';
    return src ? src.replace(/custom\.js(?:\?.*)?$/, 'matarah-search-index.json') : '';
  }

  function formatPrice(cents) {
    return (Number(cents) / 100).toFixed(2) + ' ש״ח';
  }

  function fillLivePrices(list) {
    var nodes = list.querySelectorAll('[data-matarah-price]');
    nodes.forEach(function (node) {
      var handle = node.getAttribute('data-matarah-price');
      if (!handle) return;
      if (Object.prototype.hasOwnProperty.call(priceCache, handle)) {
        if (priceCache[handle] != null) node.textContent = formatPrice(priceCache[handle]);
        return;
      }
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
        .then(function (data) {
          priceCache[handle] = data && data.price != null ? data.price : null;
          if (priceCache[handle] != null) node.textContent = formatPrice(priceCache[handle]);
        })
        .catch(function () {});
    });
  }

  function renderPrefixResults() {
    if (!products) return;

    var input = document.querySelector('.search-bar__input');
    var container = document.querySelector('.search-bar__results-inner');
    if (!input || !container) return;

    var localList = container.querySelector('.search-bar__result-products');
    var list = localList;
    if (!list) {
      list = document.createElement('div');
      list.className = 'search-bar__result-products';
      var viewAll = container.querySelector('.search-bar__view-all');
      container.insertBefore(list, viewAll || null);
    }

    var query = normalize(input.value);
    if (!query || /^\d+$/.test(query)) return;

    function searchable(value) {
      return normalize(value)
        .replace(/[\\s\\-–—|/()\\[\\]\\"',.]+/g, ' ')
        .replace(/\\s+/g, ' ')
        .trim();
    }

    var cleanQuery = searchable(query);
    var queryVariants = [cleanQuery];

    if (/ה$/.test(cleanQuery)) {
      queryVariants.push(cleanQuery.slice(0, -1) + 'ת');
    } else if (/ת$/.test(cleanQuery)) {
      queryVariants.push(cleanQuery.slice(0, -1) + 'ה');
    }

    var matches = products.map(function (product, index) {
      var title = searchable(product.t);
      var rank = 99;

      queryVariants.forEach(function (variant) {
        if (title.indexOf(variant) === 0) {
          rank = Math.min(rank, 0);
        } else if ((' ' + title).indexOf(' ' + variant) !== -1) {
          rank = Math.min(rank, 1);
        }
      });

      return { product: product, index: index, rank: rank };
    }).filter(function (entry) {
      return entry.rank < 99;
    }).sort(function (a, b) {
      return a.rank - b.rank || a.index - b.index;
    }).slice(0, 10).map(function (entry) {
      return entry.product;
    });

    // If the local product index misses a product, preserve Shopify's live suggestions.
    if (!matches.length && localList && !localList.hasAttribute('data-matarah-signature') &&
        localList.querySelector('.search-bar__result-item')) {
      return;
    }

    var signature = query + '|' + matches.map(function (product) { return product.h; }).join(',');
    if (list.getAttribute('data-matarah-signature') === signature) return;

    list.setAttribute('data-matarah-signature', signature);
    list.innerHTML = matches.map(function (product) {
      var image = product.i
        ? '<div class="search-bar__image-container"><div class="aspect-ratio aspect-ratio--square"><img src="' + escapeHtml(product.i) + '" alt="' + escapeHtml(product.t) + '" loading="lazy"></div></div>'
        : '';
      var cached = Object.prototype.hasOwnProperty.call(priceCache, product.h) && priceCache[product.h] != null;
      var price = '<span class="search-bar__item-price" data-matarah-price="' + escapeHtml(product.h) + '">' + (cached ? formatPrice(priceCache[product.h]) : '') + '</span>';
      return '<a href="/products/' + encodeURIComponent(product.h) + '" class="search-bar__result-item">' +
        image +
        '<div class="search-bar__item-info"><p class="search-bar__item-title">' + escapeHtml(product.t) + '</p>' + price + '</div>' +
        '</a>';
    }).join('');

    fillLivePrices(list);

    // Resolve each thumbnail from the live product record, so edited product photos
    // are shown in the popup even when the local search index contains an old URL.
    matches.forEach(function (product) {
      if (!product || !product.h) return;
      var productPath = '/products/' + encodeURIComponent(product.h) + '.js';
      fetch(productPath, { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
        .then(function (liveProduct) {
          if (!liveProduct || !liveProduct.featured_image) return;
          var href = '/products/' + encodeURIComponent(product.h);
          var link = Array.prototype.find.call(list.querySelectorAll('a.search-bar__result-item'), function (item) {
            return item.getAttribute('href') === href;
          });
          if (!link) return;
          var image = link.querySelector('img');
          if (image) {
            image.src = liveProduct.featured_image;
            image.removeAttribute('srcset');
          }
        })
        .catch(function () {});
    });

    var heading = container.querySelector('.search-bar__result-category');
    if (heading) {
      heading.hidden = matches.length === 0;
      heading.style.display = matches.length === 0 ? 'none' : '';
    }
  }

  function scheduleRender() {
    window.clearTimeout(renderTimer);
    window.clearTimeout(laterTimer);
    renderTimer = window.setTimeout(renderPrefixResults, 180);
    laterTimer = window.setTimeout(renderPrefixResults, 850);
  }

  var url = assetUrl();
  if (url) {
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
      .then(function (data) {
        products = Array.isArray(data) ? data : [];
        renderPrefixResults();
      })
      .catch(function () {});
  }

  document.addEventListener('input', function (event) {
    if (event.target && event.target.matches('.search-bar__input')) {
      scheduleRender();
    }
  });

  var observerTimer = null;
  var resultObserver = new MutationObserver(function () {
    if (!products) return;
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(renderPrefixResults, 40);
  });
  resultObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
